import { inject, Pipe, PipeTransform } from '@angular/core';
import { BoneTypeEnum, LanguageService, TspBoneTypeEnum } from '../../core';


/**
 * Pipe to convert Bone Type enum to display value.
 */
@Pipe({
	name: 'boneTypeLabel'
})
export class BoneTypeLabelPipe implements PipeTransform {

	private readonly langSrv = inject(LanguageService);


	transform(boneType: BoneTypeEnum | TspBoneTypeEnum | undefined): string | undefined {
		switch (boneType) {
			case BoneTypeEnum.LongLeg: return this.langSrv.labels().BONE_TYPE_LONG_LEG_LABEL;
			case TspBoneTypeEnum.LongLeg: return this.langSrv.labels().BONE_TYPE_LONG_LEG_LABEL;
			case BoneTypeEnum.Femur: return this.langSrv.labels().BONE_TYPE_FEMUR_LABEL;
			case BoneTypeEnum.Tibia: return this.langSrv.labels().BONE_TYPE_TIBIA_LABEL;
			case BoneTypeEnum.Ankle: return this.langSrv.labels().BONE_TYPE_ANKLE_LABEL;
			case BoneTypeEnum.Forefoot: return this.langSrv.labels().BONE_TYPE_FOREFOOT_LABEL;
			case BoneTypeEnum.Hindfoot: return this.langSrv.labels().BONE_TYPE_HINDFOOT_LABEL;
			default: return boneType;
		}
	}

}
